"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NavbarController_1 = __importDefault(require("./components/header/NavbarController"));
const SheetPageManager_1 = __importDefault(require("./components/content/SheetPageManager"));
const PlayerController_2_1 = __importDefault(require("./components/footer/PlayerController_2"));
// get container
const appContainer = document.getElementById('app');
if (appContainer && appContainer.children.length === 0) {
    const header = document.createElement('header');
    const content = document.createElement('main');
    const footer = document.createElement('footer');
    header.className = 'app-header';
    content.className = 'app-content';
    footer.className = 'app-footer';
    appContainer.appendChild(header);
    appContainer.appendChild(content);
    appContainer.appendChild(footer);
    const navbarController = new NavbarController_1.default(header);
    const sheetPageManager = new SheetPageManager_1.default(content);
    const playerController = new PlayerController_2_1.default(footer);
    navbarController.init();
    sheetPageManager.init();
    playerController.init();
}
else {
    console.log("Didn't find  Container");
}
